module.exports = __webpack_public_path__ + "img/customer.2d696115.svg";